export default __webpack_public_path__ + "static/media/Planmans.a9410f57.png";